import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=1dde0ac4&"
var script = {}
import style0 from "./spinner.vue?vue&type=style&index=0&id=1dde0ac4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports